import { type FunctionComponent, } from "react";
import { useEscrowStore, } from "../../stores";
import { ClaimrPoints, Eth, Dollars, } from "@components";
import { usePointsStore, } from "@stores/points";

import "./StakeStatus.scss";

export declare type StakeStatusProps = {

};	


export const StakeStatus: FunctionComponent<StakeStatusProps> = ({

}) => {

	const {
		user_stake,
		total_stake,
	} = useEscrowStore();


	const {
		total_points,
		user_points,
	} = usePointsStore();

	const classes = () => [ `stake-status` ].join(" ");


	return (
		<div className={classes()}>

			<section className="total-staked">
				<div className="label">total staked</div>
				<div className="value"><Dollars value={total_stake} loading={total_stake < 0} points={0} /></div>
			</section>

			<section className="total-points">
				<div className="label">total points</div>
				<div className="value"><ClaimrPoints value={total_points} loading={total_points < 0} /></div>
			</section>

			<section className="user-staked">
				<div className="label">you've staked</div>
				<div className="value"><Dollars value={user_stake} loading={user_stake < 0} /></div>
			</section>

			<section className="user-points">
				<div className="label">your points</div>
				<div className="value"><ClaimrPoints value={user_points} loading={user_points < 0} /></div>
			</section>

		</div>
	);


}
